import { Spinner } from '@strata/react-loading-animation';

export const SectionLoadingSpinner = () => (
    <div style={{ width: '5%' }}>
        <Spinner intent={Spinner.Intent.PRIMARY} />
    </div>
);
